/*
 * Baoba — Onglets produit : sticky nav + scrollspy + scroll fluide
 */
(function () {
  function initBaobaTabs(root) {
    if (root.dataset.baobaTabsInit) return;
    root.dataset.baobaTabsInit = 'true';

    var nav = root.querySelector('[data-baoba-tabs-nav]');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-tab-link]'));
    var panels = links
      .map(function (link) {
        var id = link.getAttribute('href').slice(1);
        return document.getElementById(id);
      })
      .filter(Boolean);

    if (!nav || !links.length || !panels.length) return;

    var stickyTicking = false;
    var scrollTicking = false;

    function computeStickyTop() {
      var header =
        document.querySelector('sticky-header') ||
        document.querySelector('[id^="shopify-section-sections--header"]') ||
        document.querySelector('.section-header') ||
        document.querySelector('.shopify-section-header');
      var offset = 0;
      if (header) {
        var rect = header.getBoundingClientRect();
        offset = Math.max(0, rect.bottom);
      }
      offset = Math.min(offset, 160);
      root.style.setProperty('--bt-sticky-top', offset + 'px');
      stickyTicking = false;
    }

    function requestStickyUpdate() {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(computeStickyTop);
    }

    function setActive(activeLink) {
      links.forEach(function (l) {
        l.classList.toggle('is-active', l === activeLink);
      });
      if (activeLink && activeLink.scrollIntoView) {
        var navInner = nav.querySelector('.baoba-tabs-nav__inner');
        if (navInner) {
          var linkRect = activeLink.getBoundingClientRect();
          var navRect = navInner.getBoundingClientRect();
          navInner.scrollLeft += linkRect.left - navRect.left - 24;
        }
      }
    }

    function updateActiveFromScroll() {
      var navHeight = nav.getBoundingClientRect().height || 0;
      var offset = parseFloat(getComputedStyle(root).getPropertyValue('--bt-sticky-top')) || 0;
      var triggerY = offset + navHeight + 16;
      var activeIdx = 0;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getBoundingClientRect().top <= triggerY) {
          activeIdx = i;
        }
      }
      setActive(links[activeIdx]);
      scrollTicking = false;
    }

    function requestScrollUpdate() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateActiveFromScroll);
    }

    computeStickyTop();
    updateActiveFromScroll();
    window.addEventListener('resize', requestStickyUpdate);
    window.addEventListener('resize', requestScrollUpdate);
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('scroll', requestScrollUpdate, { passive: true });

    links.forEach(function (link) {
      link.addEventListener('click', function (evt) {
        evt.preventDefault();
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.pageYOffset;
        var offsetTop = parseFloat(getComputedStyle(root).getPropertyValue('--bt-sticky-top')) || 0;
        window.scrollTo({ top: top - offsetTop - 8, behavior: 'smooth' });
        setActive(link);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-baoba-tabs]').forEach(initBaobaTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-baoba-tabs]');
    if (root) initBaobaTabs(root);
  });
})();
